import { render, staticRenderFns } from "./CalcPage.vue?vue&type=template&id=0fe6abe6&scoped=true&"
import script from "./CalcPage.js?vue&type=script&lang=js&"
export * from "./CalcPage.js?vue&type=script&lang=js&"
import style0 from "./CalcPage.scss?vue&type=style&index=0&id=0fe6abe6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe6abe6",
  null
  
)

export default component.exports